// extracted by mini-css-extract-plugin
export var formContainer = "_d5-0";
export var message = "_d5-1";